import { DbLoadToBeStoredItems } from "../../../data/usecases/load-to-be-stored";
import { LoadToBeStoredItems } from "../../../domain/usecases/load-to-be-stored-items";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeDbLoadToBeStoredItems = (): LoadToBeStoredItems =>
  new DbLoadToBeStoredItems(
    makeApiUrl("/store"),
    makeAuthorizeHttpClientDecorator()
  );
